/**
 * Everspring Product Card – shared interactivity
 *
 * Uses event delegation on a container so handlers survive AJAX DOM replacements
 * (e.g. after facets.js re-renders the product grid).
 *
 * Automatically initialises on DOMContentLoaded and observes #ProductGridContainer
 * for child-list mutations so the wishlist "is-active" state is re-applied after
 * filter / sort updates.
 */
(function () {
  'use strict';

  var strings = window.esCardStrings || {};

  /* ------------------------------------------------------------------
     Wishlist (localStorage)
     Stores an array of { id: "123", handle: "product-handle" } objects.
     Backwards compatible: migrates old plain-string arrays on first read.
     ------------------------------------------------------------------ */
  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem('esWishlist') || '[]');
      // Migrate old format (array of plain ID strings) to new object format
      if (raw.length > 0 && typeof raw[0] === 'string') {
        raw = raw.map(function (id) { return { id: id, handle: '' }; });
        saveWishlist(raw);
      }
      return raw;
    } catch (_) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem('esWishlist', JSON.stringify(list));
  }

  function wishlistHasId(wishlist, id) {
    return wishlist.some(function (item) { return item.id === id; });
  }

  function wishlistIndexById(wishlist, id) {
    for (var i = 0; i < wishlist.length; i++) {
      if (wishlist[i].id === id) return i;
    }
    return -1;
  }

  function applyWishlistState(scope) {
    var wishlist = getWishlist();
    var buttons = (scope || document).querySelectorAll('[data-wishlist-btn]');
    buttons.forEach(function (btn) {
      var id = btn.dataset.productId;
      if (wishlistHasId(wishlist, id)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  /* ------------------------------------------------------------------
     Event delegation – attach once to a long-lived ancestor
     ------------------------------------------------------------------ */
  function initDelegation(container) {
    if (!container || container._esCardInit) return;
    container._esCardInit = true;

    container.addEventListener('click', function (e) {
      var target = e.target;

      /* --- Wishlist toggle --- */
      var wishBtn = target.closest('[data-wishlist-btn]');
      if (wishBtn) {
        var id = wishBtn.dataset.productId;
        var card = wishBtn.closest('.es-product-card');
        var handle = card ? (card.dataset.productHandle || '') : '';
        var wishlist = getWishlist();
        var idx = wishlistIndexById(wishlist, id);
        if (idx === -1) {
          wishlist.push({ id: id, handle: handle });
          wishBtn.classList.add('is-active');
        } else {
          wishlist.splice(idx, 1);
          wishBtn.classList.remove('is-active');
        }
        saveWishlist(wishlist);
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
        return;
      }
    });
  }

  /* ------------------------------------------------------------------
     Init & observe
     ------------------------------------------------------------------ */
  function init() {
    // Delegated listeners on the grid container (survives AJAX updates)
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      initDelegation(gridContainer);

      // After facets.js replaces innerHTML, re-apply wishlist active state
      var observer = new MutationObserver(function () {
        applyWishlistState(gridContainer);
      });
      observer.observe(gridContainer, { childList: true, subtree: true });
    }

    // Also init on any es-product-grid sections (homepage etc.)
    document.querySelectorAll('.es-product-grid__grid').forEach(function (grid) {
      initDelegation(grid);
    });

    // Apply wishlist state on page load
    applyWishlistState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
